
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft } from 'lucide-react';

interface PostPreviewHeaderProps {
  postStatus: 'draft' | 'published';
  locationInfo: string | null;
}

const PostPreviewHeader: React.FC<PostPreviewHeaderProps> = ({ postStatus, locationInfo }) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <Button variant="outline" asChild>
        <Link to="/posts" className="flex items-center gap-2">
          <ArrowLeft className="h-4 w-4" />
          Back to Posts
        </Link>
      </Button>
      <div className="flex items-center gap-2">
        <Badge variant={postStatus === 'published' ? 'default' : 'outline'}>
          {postStatus === 'published' ? 'Published' : 'Draft'}
        </Badge>
        {locationInfo && (
          <Badge variant="secondary">
            Location: {locationInfo}
          </Badge>
        )}
      </div>
    </div>
  );
};

export default PostPreviewHeader;
